import * as React from "react";
import { RunResult } from "./RulesResultPanel";

export interface CustomResultContentProps {
  result: RunResult;
}

export const CustomResultContent: React.FC<CustomResultContentProps> = ({ result }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingBottom: 8 }}>
      {/* Expression (labels) */}
      {result.info?.localExpression && (
        <div style={{ color: "#111827" }}>
          <strong>{result.info.localExpression}</strong>
        </div>
      )}

      {/* Expression (values) */}
      {result.info?.evaluatedExpression && <div style={{ color: "#111827" }}>{result.info.evaluatedExpression}</div>}

      {/* Messaggio a livello di script (errore o informativo) */}
      {result.info?.message && (
        <div style={{ color: result.info.status === "ERROR" ? "#b91c1c" : "#374151", fontSize: 12 }}>
          {result.info.message}
        </div>
      )}
    </div>
  );
};
